/**
 * Main keys are the same as the translation keys. See: /locales.
 */
module.exports = {
  en: {
    supportedLocales: {
      en: {
        domain: 'www.ticketswap.com',
        devDomain: 'com',
      },
      'en-GB': {
        domain: 'www.ticketswap.uk',
        devDomain: 'uk',
      },
      'en-IE': {
        domain: 'www.ticketswap.ie',
        devDomain: 'ie',
      },
      'en-AU': {
        domain: 'www.ticketswap.com.au',
        devDomain: 'com-au',
      },
    },
    mainLocale: 'en',
    languageSpecificNames: {
      en: 'English',
      de: 'German',
      fr: 'French',
      es: 'Spanish',
      hu: 'Hungarian',
      nl: 'Dutch',
      it: 'Italian',
      sv: 'Swedish',
      'pt-BR': 'Brazilian Portuguese',
    },
  },
  nl: {
    supportedLocales: {
      'nl-NL': {
        domain: 'www.ticketswap.nl',
        devDomain: 'nl',
      },
      'nl-BE': {
        domain: 'www.ticketswap.be',
        devDomain: 'be',
      },
    },
    mainLocale: 'nl-NL',
    languageSpecificNames: {
      en: 'Engels',
      de: 'Duits',
      fr: 'Frans',
      es: 'Spaans',
      hu: 'Hongaars',
      nl: 'Nederlands',
      it: 'Italiaans',
      sv: 'Zweeds',
      'pt-BR': 'Braziliaans Portugees',
    },
  },
  fr: {
    supportedLocales: {
      'fr-FR': {
        domain: 'www.ticketswap.fr',
        devDomain: 'fr',
      },
      'fr-BE': {
        domain: 'fr.ticketswap.be',
        devDomain: 'fr-be',
      },
      'fr-CH': {
        domain: 'fr.ticketswap.ch',
        devDomain: 'fr-ch',
      },
    },
    mainLocale: 'fr-FR',
    languageSpecificNames: {
      en: 'Anglais',
      de: 'Allemand',
      fr: 'Français',
      es: 'Espagnol',
      hu: 'Hongrois',
      nl: 'Hollandais',
      it: 'Italien',
      sv: 'Suédois',
      'pt-BR': 'Portugais brésilien',
    },
  },
  de: {
    supportedLocales: {
      'de-DE': {
        domain: 'www.ticketswap.de',
        devDomain: 'de',
      },
      'de-CH': {
        domain: 'www.ticketswap.ch',
        devDomain: 'ch',
      },
      'de-AT': {
        domain: 'www.ticketswap.at',
        devDomain: 'at',
      },
    },
    mainLocale: 'de-DE',
    languageSpecificNames: {
      en: 'Englisch',
      de: 'Deutsch',
      fr: 'Französisch',
      es: 'Spanisch',
      hu: 'Ungarisch',
      nl: 'Holländisch',
      it: 'Italienisch',
      sv: 'Schwedisch',
      'pt-BR': 'Brasilianisches Portugiesisch',
    },
  },
  es: {
    supportedLocales: {
      'es-ES': {
        domain: 'www.ticketswap.es',
        devDomain: 'es',
      },
    },
    mainLocale: 'es-ES',
    languageSpecificNames: {
      en: 'Inglés',
      de: 'Alemán',
      fr: 'Francés',
      es: 'Español',
      hu: 'Húngaro',
      nl: 'Holandés',
      it: 'Italiano',
      sv: 'Sueco',
      'pt-BR': 'Portugués brasileño',
    },
  },
  hu: {
    supportedLocales: {
      'hu-HU': {
        domain: 'www.ticketswap.hu',
        devDomain: 'hu',
      },
    },
    mainLocale: 'hu-HU',
    languageSpecificNames: {
      en: 'Angol',
      de: 'Német',
      fr: 'Francia',
      es: 'Spanyol',
      hu: 'Magyar',
      nl: 'Holland',
      it: 'Olasz',
      sv: 'Svéd',
      'pt-BR': 'Brazil portugál',
    },
  },
  it: {
    supportedLocales: {
      'it-IT': {
        domain: 'www.ticketswap.it',
        devDomain: 'it',
      },
    },
    mainLocale: 'it-IT',
    languageSpecificNames: {
      en: 'Inglese',
      de: 'Tedesco',
      fr: 'Francese',
      es: 'Spagnolo',
      hu: 'Ungherese',
      nl: 'Olandese',
      it: 'Italiano',
      sv: 'Svedese',
      'pt-BR': 'Portoghese brasiliano',
    },
  },
  sv: {
    supportedLocales: {
      'sv-SE': {
        domain: 'www.ticketswap.se',
        devDomain: 'se',
      },
    },
    mainLocale: 'sv-SE',
    languageSpecificNames: {
      en: 'Engelska',
      de: 'Tyska',
      fr: 'Franska',
      es: 'Spanska',
      hu: 'Ungerska',
      nl: 'Nederländska',
      it: 'Italienska',
      sv: 'Svenska',
      'pt-BR': 'Portugisiska Brasilianska',
    },
  },
  'pt-BR': {
    supportedLocales: {
      'pt-BR': {
        domain: 'www.ticketswap.com.br',
        devDomain: 'com-br',
      },
    },
    mainLocale: 'pt-BR',
    languageSpecificNames: {
      en: 'Inglese',
      de: 'Tedesco',
      fr: 'Francese',
      es: 'Spagnolo',
      hu: 'Ungherese',
      nl: 'Olandese',
      it: 'Italiano',
      sv: 'Sueco',
      'pt-BR': 'Português Brasileiro',
    },
  },
}
